import { Trophy } from "lucide-react";
export const CompletionHeader = () => {
  return <div className="relative">
      <div className="absolute inset-0 bg-primary/20 rounded-full animate-[pulse_2s_ease-in-out_infinite]" />
      
    </div>;
};